var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 18,
  viewBox: "0 0 15 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "nonzero",
  d: "M7.852 17.293c.924 0 1.68-.755 1.68-1.679H6.173c0 .924.756 1.68 1.68 1.68zm5.458-5.038V7.637c0-2.603-1.763-4.702-4.198-5.29V1.76C9.112 1.088 8.524.5 7.852.5c-.671 0-1.26.588-1.26 1.26v.587c-2.434.588-4.197 2.687-4.197 5.29v4.618l-1.68 1.68v.84H14.99v-.84l-1.68-1.68z"
})));
export default __webpack_public_path__ + "teg/media/bell.f7fa639a.svg";
export { SvgComponent as ReactComponent };